(function () {
  if (customElements.get('how-it-works-video')) return;

  customElements.define(
    'how-it-works-video',
    class HowItWorksVideo extends HTMLElement {
      constructor() {
        super();
        this._hideTimer = null;
        this._pointerInside = false;
        this._bound = {};
        this._initialized = false;
      }

      static getActiveVideo(root) {
        const isDesktop = window.matchMedia('(min-width: 990px)').matches;
        const single = root.querySelector('.lp-how-it-works__video--single');
        if (single) return single;
        const desktop = root.querySelector('.lp-how-it-works__video--desktop');
        const mobile = root.querySelector('.lp-how-it-works__video--mobile');
        return isDesktop ? desktop : mobile;
      }

      static getInactiveVideos(root) {
        const active = HowItWorksVideo.getActiveVideo(root);
        return Array.prototype.filter.call(root.querySelectorAll('video'), (v) => v !== active);
      }

      connectedCallback() {
        if (this._initialized) return;

        const overlay = this.querySelector('.lp-how-it-works__video-overlay');
        if (!overlay) return;

        const media = this.querySelector('.lp-how-it-works__media');
        const videos = this.querySelectorAll('video');
        if (!media || !videos.length) return;

        const self = this;

        this._bound.mediaPointerEnter = () => {
          self._pointerInside = true;
          self._clearHideTimer();
          self._updateOverlayVisibility();
        };
        this._bound.mediaPointerLeave = () => {
          self._pointerInside = false;
          const active = HowItWorksVideo.getActiveVideo(self);
          if (active && !active.paused) {
            self._scheduleHidePause();
          } else {
            self._updateOverlayVisibility();
          }
        };
        this._bound.overlayClick = (e) => {
          e.preventDefault();
          const v = HowItWorksVideo.getActiveVideo(self);
          if (!v) return;
          if (v.paused) {
            HowItWorksVideo.getInactiveVideos(self).forEach((inactive) => {
              inactive.pause();
            });
            v.play().catch(() => {});
          } else {
            v.pause();
          }
          self._updateOverlayVisibility();
        };
        this._bound.videoPlayPause = () => {
          HowItWorksVideo.getInactiveVideos(self).forEach((inactive) => {
            inactive.pause();
          });
          self._updateOverlayVisibility();
        };
        this._bound.resize = () => {
          HowItWorksVideo.getInactiveVideos(self).forEach((inactive) => {
            inactive.pause();
          });
          self._updateOverlayVisibility();
        };

        media.addEventListener('pointerenter', this._bound.mediaPointerEnter);
        media.addEventListener('pointerleave', this._bound.mediaPointerLeave);
        overlay.addEventListener('click', this._bound.overlayClick);
        videos.forEach((v) => {
          v.addEventListener('play', this._bound.videoPlayPause);
          v.addEventListener('pause', this._bound.videoPlayPause);
        });
        window.addEventListener('resize', this._bound.resize);

        this._initialized = true;
        this._updateOverlayVisibility();
      }

      disconnectedCallback() {
        if (!this._initialized) return;

        const overlay = this.querySelector('.lp-how-it-works__video-overlay');
        const media = this.querySelector('.lp-how-it-works__media');
        const videos = this.querySelectorAll('video');

        this._clearHideTimer();

        if (media && this._bound.mediaPointerEnter) {
          media.removeEventListener('pointerenter', this._bound.mediaPointerEnter);
          media.removeEventListener('pointerleave', this._bound.mediaPointerLeave);
        }
        if (overlay && this._bound.overlayClick) {
          overlay.removeEventListener('click', this._bound.overlayClick);
        }
        if (videos.length && this._bound.videoPlayPause) {
          videos.forEach((v) => {
            v.removeEventListener('play', this._bound.videoPlayPause);
            v.removeEventListener('pause', this._bound.videoPlayPause);
          });
        }
        if (this._bound.resize) {
          window.removeEventListener('resize', this._bound.resize);
        }

        this._initialized = false;
      }

      _clearHideTimer() {
        if (this._hideTimer) {
          clearTimeout(this._hideTimer);
          this._hideTimer = null;
        }
      }

      _scheduleHidePause() {
        this._clearHideTimer();
        const active = HowItWorksVideo.getActiveVideo(this);
        if (!active || active.paused) return;

        this._hideTimer = window.setTimeout(() => {
          this._hideTimer = null;
          this._updateOverlayVisibility();
        }, 3000);
        this._updateOverlayVisibility();
      }

      _updateOverlayVisibility() {
        const overlay = this.querySelector('.lp-how-it-works__video-overlay');
        const active = HowItWorksVideo.getActiveVideo(this);
        if (!overlay || !active) return;

        if (active.paused) {
          this._clearHideTimer();
          overlay.classList.remove('lp-how-it-works__video-overlay--state-playing');
          overlay.classList.add('lp-how-it-works__video-overlay--state-paused', 'lp-how-it-works__video-overlay--visible');
          overlay.setAttribute('aria-label', 'Play video');
          return;
        }

        overlay.classList.remove('lp-how-it-works__video-overlay--state-paused');
        overlay.classList.add('lp-how-it-works__video-overlay--state-playing');

        const showPauseOverlay = this._pointerInside || this._hideTimer != null;
        if (showPauseOverlay) {
          overlay.classList.add('lp-how-it-works__video-overlay--visible');
        } else {
          overlay.classList.remove('lp-how-it-works__video-overlay--visible');
        }
        overlay.setAttribute('aria-label', 'Pause video');
      }
    }
  );
})();
